import { createSlice } from "@reduxjs/toolkit";

export const cartPopUp = createSlice({
  name: "cartPopUp",
  initialState: {
    isOpen: false,
  },
  reducers: {
    togglePopUp: (state) => {
      state.isOpen = !state.isOpen;
    },
  },
});

export const { togglePopUp } = cartPopUp.actions;

export const cartPopUpReducer = cartPopUp.reducer;
